<template>
  <div class="region-searh-wrapper">
    <div class="wrapper">
      <div class="title">
        按乡镇选择 <span class="fa fa-close" @click="closePanle()"></span>
      </div>
      <div class="content">
        <div class="filter">
          <div class="town-list">
            <el-radio-group v-model="selectedTownName">
              <el-radio
                class="town"
                :label="town.lable"
                v-for="(town, index) in regionList"
                :key="index"
                >{{ town.lable }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="village-list">
            <div
              class="feature"
              v-for="(item, index) in villageList"
              :key="index"
            >
              <el-checkbox v-model="item.checked">{{ item.lable }}</el-checkbox>
            </div>
          </div>
          <div class="submit">
            <el-button size="small" type="primary" @click="searchFeature()"
              >开始查询</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <SearchResult
      :searchResult="searchResult"
      v-if="searchResult"
    ></SearchResult>
  </div>
</template>
<script>
import SearchResult from "./SearchResult.vue";
export default {
  name: "regionSearchManage",
  props: {
    closeAllPanel: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isSearching: false,
      selectedTownName: "王平镇",
      villageList: [],
      searchResult: [],
      regionList: [
        {
          lable: "王平镇",
          center: [115.99, 40.0048],
          childrens:
            "安家庄村,吕家坡村,东王平村,西王平村,河北村,色树坟村,南涧村,西石古岩,东马各庄村,东石古岩,西马各庄村,西落坡村,南港村,东落坡村,韭园村,桥耳涧村",
        },
        {
          lable: "永定镇",
          center: [116.1045, 39.8999],
          childrens:
            "南区,北区,冯村,侯庄子村,苛萝坨村,卧龙岗村,万佛堂村,何各庄村,石佛村,秋坡村,西辛称村,石门营村,王村,东辛称村,白庄子村,石厂村,曹各庄村,上岸村,艾洼村,坝房子村,贵石村,桥户营村,四道桥村,卫星队村,栗园庄村",
        },
        {
          lable: "龙泉镇",
          center: [116.0777, 39.9605],
          childrens:
            "东南街,梨园,琉璃渠,龙泉务,水闸西路,西前街,龙泉务村,东龙门村,城子村,大峪村,东辛房村,滑石道村,琉璃渠村,门头口村,三店村,三家店村,石港村,天桥浮村,西龙门村,西辛房村,岳家坡村,赵家洼村,中门寺村,三家店一分社,三家店三分社",
        },
        {
          lable: "潭柘寺镇",
          center: [116.0111, 39.8904],
          childrens:
            "北村,东村,南村,鲁家滩村,南辛房村,桑峪村,平原村,王坡村,贾沟村,草甸水村,赵家台村,阳坡元村",
        },
        {
          lable: "军庄镇",
          center: [116.12105, 40.0084],
          childrens:
            "惠通新苑,杨坨,北四,军庄村,灰峪村,西杨坨村,东杨坨村,孟悟村,新村,东山村,香峪村",
        },
        {
          lable: "雁翅镇",
          center: [115.8766, 40.0711],
          childrens:
            "河南台村,雁翅村,芹峪村,下马岭村,饮马鞍村,太子墓村,付家台村,青白口村,珠窝村,碣石村,黄土贵村,泗家水村,淤白村,高台村,松树村,田庄村,苇子水村,大村,房良村,杨村,马套村,山神庙村,跃进村",
        },
        {
          lable: "斋堂镇",
          center: [115.6946, 40.0177],
          childrens:
            "高铺村,沿河口村,东斋堂村,杨家村,沿河城村,杨家峪村,新兴村,向阳口村,西斋堂村,西胡林,王龙口村,双石头村,桑峪村,青龙涧村,牛战村,张家村,马栏村,吕家村,龙门口村,灵水村,林字台村,军响村,火村,黄岭西村,法城村",
        },
        {
          lable: "清水镇",
          center: [115.577, 39.9461],
          childrens:
            "洪水峪村,洪水口村,椴木沟村,杜家庄村,达摩庄村,八亩堰村,艾峪村,张家庄村,张家铺村,燕家台村,小龙门村,下清水村,西达摩村,田寺村,天河水村,台上村,塔河村,双塘涧村,胜利村,双涧子村,上清水村,齐家庄村,上达么村,龙王村,梁家庄村",
        },
        {
          lable: "妙峰山镇",
          center: [116.0635, 40.0316],
          childrens:
            "陇驾庄村,丁家滩村,水玉咀村,斜河涧村,陈家庄村,担礼村,下苇甸村,桃园村,南庄村,樱桃沟村,涧沟村,上苇甸村,炭厂村,大沟村,禅房村,黄台村,岭角村,妙峰山东方小区",
        },
        {
          lable: "大峪街道",
          center: [116.11, 39.9374],
          childrens:
            "德露苑,月季园东里,月季园,月季园二,新桥南大街,双峪二,双峪,向阳楼,向东,向阳东里,龙泉花园,剧场东街,河滩西街,增产路,龙门河滩,黑山西街,空心砖,由字房,西南横,建井,坡头东街,新自建,坡头西街,坡头南街,南路一,南路二,南路三,峪园,峪园南里,永新,桃园,增产路东,东南横,黑山东街,新桥路,新桥街西,新楼,大峪街,承泽苑,中门花园",
        },
        {
          lable: "城子街道",
          center: [116.1, 39.9505],
          childrens:
            "市场,桥东街,城子大街,民生,城子西街,七棵树东街,广场,向阳,七棵树西街,矿桥东街,西宁路,华新建,新老宿舍,蓝龙家园,龙门新区一区,龙门新区三区,龙门新区四区,龙门新区五区,龙门新区六区,燕保家园",
        },
        {
          lable: "大台街道",
          center: [115.81, 39.9482],
          childrens: "落坡岭,桃园,双红,大台,黄土台,灰地,玉皇庙,木城涧,千军台",
        },
        {
          lable: "东辛房街道",
          center: [116.1, 39.9304],
          childrens:
            "北涧沟,河南街,建设街,矿建街,滑石道,西山,圈门,石门营新区一区,石门营新区五区,石门营新区六区,石门营新区七区,石门营新区四区,石门营新区二区",
        },
      ],
    };
  },
  watch: {
    selectedTownName() {
      for (let i = 0; i < this.regionList.length; i++) {
        if (this.regionList[i].lable == this.selectedTownName) {
          let view = this.xxMap.getMainMap().getView();
          let center = this.regionList[i].center;
          view.setCenter(center);

          view.setZoom(13);
          let childrens = this.regionList[i].childrens.split(",");
          let villageList = [];
          childrens.forEach((item, index) => {
            let checked = false;
            if (index == 0) {
              checked = true;
            }
            let obj = {
              checked: checked,
              lable: item,
            };
            villageList.push(obj);
          });
          this.villageList = villageList;
          break;
        }
      }
    },
  },
  computed: {},
  components: { SearchResult },
  methods: {
    //按照装属性查找要素
    searchFeature() {
      if (this.isSearching) {
        this.$message("查询中，请无重复提交！");
        return;
      }
      if (this.villageList.length == 0) {
        this.$message("请您选择行政区！");
        return;
      }
      let villageList = [];
      this.villageList.forEach((item) => {
        if (item.checked) {
          villageList.push(item.lable);
        }
      });
      let data = {
        villageList: villageList.join(","),
      };
      let url = "/api/gis_app/culture_search_by_region/";
      this.isSearching = true;
      this.$axios({
        url: url,
        method: "post",
        data: data,
      }).then((res) => {
        let { status, data } = res.data;
        if (status === 200) {
          let pointData = data.point ? data.point : [];
          let lineData = data.line ? data.line : [];
          let polygonData = data.polygon ? data.polygon : [];

          let point_gids = [];
          pointData.forEach((item, index) => {
            item.index = index + 1;
            point_gids.push(item.gid);
          });

          let line_gids = [];
          lineData.forEach((item, index) => {
            item.index = index + 1;
            line_gids.push(item.gid);
          });

          let polygon_gids = [];
          polygonData.forEach((item, index) => {
            item.index = index + 1;
            polygon_gids.push(item.gid);
          });

          this.$store.commit("setSearchResultFeatureIDs", {
            point_gids: point_gids,
            line_gids: line_gids,
            polygon_gids: polygon_gids,
          });

          this.searchResult = [...pointData, ...lineData, ...polygonData];
          if (this.searchResult.length == 0) {
            this.$message("没有查询到数据!");
          }
        }
        this.isSearching = false;
      });
    },
    closePanle() {
      this.$store.commit("setSearchResultFeatureIDs", {
        point_gids: null,
        line_gids: null,
        polygon_gids: null,
      });
      this.closeAllPanel();
      this.$store.commit("setSearchResultDialogType", 0);
    },
  },
  mounted() {
    let childrens = this.regionList[0].childrens.split(",");
    let villageList = [];
    childrens.forEach((item, index) => {
      let checked = false;
      if (index == 0) {
        checked = true;
      }
      let obj = {
        checked: checked,
        lable: item,
      };
      villageList.push(obj);
    });
    this.villageList = villageList;
  },
};
</script>
 
<style scoped lang="less" >
.region-searh-wrapper {
  position: absolute;
  width: 500px;
  top: 0px;
  left: 45px;
  z-index: 99;
  background: #fff;
  border: solid 1px #ccc;
  padding: 10px;
  .wrapper {
    border: solid 1px #ccc;
    .title {
      background-color: #f3f8ff;
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      font-size: 15px;
      span:nth-child(1) {
        color: #355ba6;
        margin-right: 5px;
        font-weight: bold;
      }
      .fa-close {
        float: right;
        font-size: large;
        color: #9f9c9c;
        margin-top: 7px;
        margin-right: 10px;
      }
      .fa-close:hover {
        cursor: pointer;
        color: #706e6e;
      }
    }
    .content {
      padding: 10px 5px 5px;
      .filter {
        padding: 0;
        .town-list {
          margin-bottom: 10px;
          border-bottom: dashed 1px #ccc;
          .town {
            width: 25%;
            display: inline-block;
            margin-right: 0;
            margin-bottom: 5px;
          }
        }
        .village-list {
          margin-bottom: 5px;
          .feature {
            display: inline-block;
            width: 25%;
            text-align: left;

            /deep/.el-checkbox__label {
              padding-left: 1px;
            }
          }
        }

        .submit {
          text-align: right;
        }
      }
    }
  }
}
</style>

 